export type AssignmentSource = "user"
  | "identity_pool_defaults"
  | "external_roles";


export const FRIENDLY_ASSIGNMENT_SOURCES: {[key: string]: string} = {
  user: "User",
  identity_pool_defaults: "Identity Pool Defaults",
  external_roles: "External Roles",
};
